(ns practitest.frontend.components.grid.events
  (:require [re-frame.core :as re-frame]
            [practitest.frontend.components.grid.subs :as grid.subs]
            [clojure.set]))

;;; ::toggle-selection
;; TODO: remove clear? flag (replace with clear-selection)
(defn toggle-selection [db [_ path id clear?]]
  (update-in db (cons :entity path)
             (fn [state]
               (if (= :all id)
                 (let [all-ids (set (map :id (:data state)))]
                   (assoc state :selection
                          (if (or clear?
                                  (= (:selection state) all-ids))
                            #{}
                            all-ids)))
                 (update state :selection
                         (fn [selection]
                           (if (grid.subs/full-selection? selection)
                             ;; Do nothing in case of full-selection mode
                             selection
                             (if (nil? selection)
                               ;; Init set
                               #{id}
                               (if (contains? selection id)
                                 (disj selection id)
                                 (conj selection id))))))))))

(re-frame/reg-event-db
 ::toggle-selection
 toggle-selection)

(defn toggle-selection-page [db [_ path page-items]]
  (update-in db (cons :entity path)
             (fn [state]
               (let [all-ids (set (map :id page-items))]
                 (update state :selection
                         (fn [selection]
                           (if (grid.subs/full-selection? selection)
                             #{}
                             ;; Every item is selected - reset
                             (if (clojure.set/subset? all-ids selection)
                               (clojure.set/difference selection all-ids)
                               (clojure.set/union selection all-ids)))))))))

(re-frame/reg-event-db
  ::toggle-selection-page
  toggle-selection-page)

(re-frame/reg-event-db
  ::clear-selection
  (fn [db [_ path]]
    (assoc-in db (concat [:entity] path [:selection]) #{})))

(re-frame/reg-event-fx
  ::select-all
  (fn [{db :db} [_ path]]
    {:db (assoc-in db (concat [:entity] path [:selection]) :_all)}))

(re-frame/reg-event-db
  ::select-one
  (fn [db [_ path id]]
    (assoc-in db (concat [:entity] path [:selection]) #{id})))
